import { CSSProperties } from "react";
import CloseIcon from "../../Element/CloseIcon/CloseIcon";
import styles from "./MobileBanner.module.css";
import { ImageCrop } from "../../Utility/dataTypes";
import ResponsiveImage from "../../Element/ResponsiveImage";
import Marquee from "./Marquee";

type Props = {
  href: string;
  dangerouslySetInnerHTML: {
    __html: string;
  };
  onClose?: () => void;
  contentListOpts?: {
    backgroundColor?: string;
    color?: string;
    showOnDesktop?: string;
  };
  image?: ImageCrop;
  imageWidth?: number;
  imageHeight?: number;
  scroll?: boolean;
  scrollDuration?: number;
  scrollItemCount?: number;
};

export default function MobileBanner({
  href,
  onClose,
  dangerouslySetInnerHTML,
  contentListOpts,
  image,
  imageWidth = 40,
  imageHeight = 40,
  scroll,
  scrollDuration = 20,
  scrollItemCount = 3,
}: Props) {
  const style: CSSProperties & {
    "--mobile-banner-mobile-up-display"?: string;
    "--mobile-banner-background-color"?: string;
    "--mobile-banner-color"?: string;
    "--mobile-banner-image-width"?: string;
    "--mobile-banner-image-height"?: string;
    "--mobile-banner-scroll-duration"?: string;
  } = {};

  style["--mobile-banner-mobile-up-display"] =
    contentListOpts?.showOnDesktop && "flex";
  style["--mobile-banner-background-color"] = contentListOpts?.backgroundColor;
  style["--mobile-banner-color"] = contentListOpts?.color;
  style["--mobile-banner-image-width"] = `${imageWidth}px`;
  style["--mobile-banner-image-height"] = `${imageWidth}px`;
  style["--mobile-banner-scroll-duration"] = `${scrollDuration}s`;

  const bannerContent = (
    <>
      {image?.src && (
        <div className={styles.image}>
          <ResponsiveImage
            src={image.src}
            alt={image.alt || ""}
            srcWidth={imageWidth}
            srcHeight={imageHeight}
            displayWidth={imageWidth}
          />
        </div>
      )}
      <span dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
    </>
  );

  return (
    <div className={styles.container} style={style}>
      <a className={styles.link} href={href}>
        {scroll ? (
          <Marquee scrollItemCount={scrollItemCount}>{bannerContent}</Marquee>
        ) : (
          bannerContent
        )}
      </a>
      {onClose && !scroll && (
        <button className={styles.close} onClick={onClose}>
          <CloseIcon size={12} strokeWidth={1} />
        </button>
      )}
    </div>
  );
}
